import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import notFound from "../../assets/imgs/not-found.png";
import GeneralButton from "../../components/button/GeneralButton";
import OrderBillingAddressCard from "../../components/cards/OrderBillingAddressCard";
import OrderShippingAddressCard from "../../components/cards/OrderShippingAddressCard";

import SaleItemCard from "../../components/cards/SaleItemCard";
import SaleOrderInformations from "../../components/cards/SaleOrderInformations";
import SaleOrderTotalCard from "../../components/cards/SaleOrderTotalCard";
import AddNewCreditCard from "../../components/modals/AddNewCreditCard";
import AddOrderItem from "../../components/modals/AddOrderItem";
import AddShippingModal from "../../components/modals/AddShippingModal";
import CreatePurchaseOrder from "../../components/modals/CreatePurchaseOrder";
import ItemSelectionInvoiceModal from "../../components/modals/ItemSelectionInvoiceModal";
import PackagingSlipModal from "../../components/modals/PackagingSlipModal";
import SalesOrderLinks from "../../components/navLinks/SalesOrderLinks";
import PageName from "../../components/react_helmet/PageName";
import CustomOrderNotes from "../../components/table/CustomOrderNotes";
import LogTable from "../../components/table/LogTable";
import PosInsideSo from "../../components/table/PosInsideSo";
import { orderStatuses } from "../../data";
import useSalesOrderDetails from "./customHooks/useSalesOrderDetails";
import SaleOrderStatuses from "../../components/cards/SaleOrderStatuses";
import { BiArrowToTop, BiArrowToBottom, BiCheckCircle } from "react-icons/bi";
import { FiFileText, FiSend } from "react-icons/fi";
import OrderDetailsSkeleton from "../../components/skeleton/OrderDetailsSkeleton";
const SalesOrderDetails = (props) => {
  const {
    toggleItemModal,
    itemModal,
    togglecreditCardModal,
    creditCardModal,
    purchaseOrderModal,
    togglepurchaseOrderModal,
    shippingModal,
    toggleShippingModal,
    packageSlipModal,
    togglePackageSlipModal,
    billingData,
    setBillingData,
    shippingData,
    setShippingData,
    orderStatus,
    setOrderStatus,
    orderNotes,
    totalTaxAmount,
    setTotalTaxAmount,
    subTotal,
    totalAmount,
    orderNumber,
    setOrderNumber,
    set_return_status,
    return_status,
    shipBy,
    setShipBy,
    line_items,
    setLineItems,
    note,
    setNote,
    addOrderNote,
    all_vendors,
    shippingCheckboxes,
    setShippingCheckboxes,
    handleSubmitOrder,
    poDetails,
    paymentStatus,
    setPaymentStatus,
    orderData,
    setOrderData,
    setNewLineItems,
    handleOrderQuickBooks,
    loading,
    totalTax,
    loader,
    creationDate,
    setCreationDate,
    returnOrder,
    returnVendor,
    setReturnVendor,
    state,
    returnOrders,
    selectedOrdersIds,
    setSelectedOrdersIds,
    orderLabels,
    customer_acc,
    setCustomerAcc,
    orderCritical,
    setOrderCritical,
    setOrderNotes,
    dataLoading, inoiceModal,
    toggleInvoiceModal,
    sendNoteToCustomer, noteloader,
    handleCapturePayment,
    captureLoading, pageLoader, stockData, distributorStockLoading, refreshSaleOrderDetails, viewers,
    deleteOrderNote, updateOrderNote
  } = useSalesOrderDetails(props);

  if (dataLoading) {
    return (
      <div className="mt-4">
        <OrderDetailsSkeleton />
      </div>
    );
  }
  return (
    <>
      <PageName title={"Sales Details"} />
      {loading ? (
        <div className="mt-4">
          <OrderDetailsSkeleton />
        </div>
      ) : (
        <>
          {
            inoiceModal && (
              <ItemSelectionInvoiceModal
                modal={inoiceModal}
                toggle={toggleInvoiceModal}
                line_items={line_items}
                setLineItems={setLineItems}
                state={orderData}
              />
            )
          }
          {itemModal && (
            <AddOrderItem
              toggle={toggleItemModal}
              modal={itemModal}
              setLineItems={setLineItems}
              line_items={line_items}
              orderData={orderData}
              setOrderData={setOrderData}
              setNewLineItems={setNewLineItems}
            />
          )}
          {creditCardModal && (
            <AddNewCreditCard
              toggle={togglecreditCardModal}
              modal={creditCardModal}
              state={orderData}
            />
          )}
          {purchaseOrderModal && (
            <CreatePurchaseOrder
              modal={purchaseOrderModal}
              toggle={togglepurchaseOrderModal}
              all_vendors={all_vendors ?? []}
              state={orderData}
              directPO={false}
              returnVendor={returnVendor}
              setReturnVendor={setReturnVendor}
              returnOrder={returnOrder}
              selectedOrdersIds={selectedOrdersIds}
              setSelectedOrdersIds={setSelectedOrdersIds}
            />
          )}
          {shippingModal && (
            <AddShippingModal
              modal={shippingModal}
              toggle={toggleShippingModal}
              items={line_items}
              shipBy={shipBy}
              shippingData={shippingData}
              orderData={orderData}
              customer_acc={customer_acc}
              refreshSaleOrderDetails={refreshSaleOrderDetails}
            />
          )}
          {packageSlipModal && (
            <PackagingSlipModal
              modal={packageSlipModal}
              toggle={togglePackageSlipModal}
              line_items={line_items}
              setLineItems={setLineItems}
              state={orderData}
            />
          )}
          <SalesOrderLinks
            state={orderData}
            orderLabels={orderLabels}
            togglepurchaseOrderModal={togglepurchaseOrderModal}
            toggleShippingModal={toggleShippingModal}
            togglecreditCardModal={togglecreditCardModal}
            togglePackageSlipModal={togglePackageSlipModal}
            handleSubmitOrder={handleSubmitOrder}
            loader={loader}
            fromPDF={state?.fromPOPdf}
            returnVendor={returnVendor}
            setReturnVendor={setReturnVendor}
            toggle={togglepurchaseOrderModal}
            toggleInvoiceModal={toggleInvoiceModal}
            handleCapturePayment={handleCapturePayment}
            captureLoading={captureLoading}
            loading={loading}
          />

          {paymentStatus === "Paid" && (
            <div className="alert alert-success d-flex align-items-center justify-content-center gap-3 rounded-0 mb-2 shadow-sm py-1 border-0 border-start border-5 border-success" style={{ backgroundColor: "#e6fffa" }}>
              <div className="bg-success rounded-circle p-1 d-flex align-items-center justify-content-center shadow-sm">
                <BiCheckCircle size={17} className="text-white" />
              </div>
              <div>
                <h5 className="mb-0 fw-bold text-success uppercase tracking-widest" style={{ fontSize: '18px' }}>Payment Completed</h5>

              </div>
            </div>
          )}


          <Row className="mb-2">
            <Col md={3}>
              <OrderBillingAddressCard
                title="Bill To"
                billingData={billingData}
                setBillingData={setBillingData}
                shippingCheckboxes={shippingCheckboxes}
                setShippingCheckboxes={setShippingCheckboxes}
              />
            </Col>
            <Col md={3}>
              <OrderShippingAddressCard
                title="Ship To"
                shippingData={shippingData}
                setShippingData={setShippingData}
                shippingCheckboxes={shippingCheckboxes}
                setShippingCheckboxes={setShippingCheckboxes}
                saleOrder={true}
                order={orderData}
                setOrderNotes={setOrderNotes}
                customer_acc={customer_acc}
                setCustomerAcc={setCustomerAcc}
              />
            </Col>
            <Col md={3}>
              <SaleOrderInformations
                state={orderData}
                orderNumber={orderNumber}
                setOrderNumber={setOrderNumber}
                shipBy={shipBy}
                setShipBy={setShipBy}
                orderData={orderData}
                creationDate={creationDate}
                setCreationDate={setCreationDate}
                returnOrders={returnOrders}
                customer_acc={customer_acc}
                setCustomerAcc={setCustomerAcc}
              />
            </Col>
            <Col md={3}>
              <SaleOrderStatuses
                orderStatuses={orderStatuses}
                orderStatus={orderStatus}
                setOrderStatus={setOrderStatus}
                return_status={return_status}
                set_return_status={set_return_status}
                setPaymentStatus={setPaymentStatus}
                paymentStatus={paymentStatus}
                orderData={orderData}
                orderCritical={orderCritical}
                setOrderCritical={setOrderCritical}
                orderNotes={orderNotes}
                setOrderNotes={setOrderNotes}
              />
            </Col>
          </Row>
          <div className="mb-2 d-flex justify-content-between align-items-center ">
            <h4>Items</h4>
            <button
              className="text-primary  px-2 py-1 border border-primary bg-white rounded-0"
              onClick={toggleItemModal}
            >
              Add Item
            </button>
          </div>
          <Row>
            {line_items?.length > 0 ? (
              line_items?.map((item, index) => (
                <div className="item_body_wrapper" key={item._id}>
                  <SaleItemCard
                    index={index}
                    data={item}
                    line_items={line_items}
                    setLineItems={setLineItems}
                    poDetails={poDetails}
                    labels={item?.labels}
                    orderData={orderData}
                    toggleShippingModal={toggleShippingModal}
                    orderLabels={orderLabels}
                    stockData={stockData}
                    distributorStockLoading={distributorStockLoading}
                    dataLoading={dataLoading}
                    pageLoading={pageLoader}
                    refreshSaleOrderDetails={refreshSaleOrderDetails}
                  />
                </div>
              ))
            ) : (
              <Card className="items__notfound rounded-0 mt-3 ">
                <p>No Items Found </p>
                <img src={notFound} className="notFoundImage" alt="" />
              </Card>
            )}
          </Row>
          <Row className="mb-4 d-flex align-items-stretch gy-4">
            <Col md={8}>
              <Card className="border-0 shadow-sm h-100">
                <CardBody className="p-4 d-flex flex-column">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="bg-primary-soft p-2 rounded-circle text-primary">
                      <FiFileText size={18} />
                    </div>
                    <h5 className="fw-bold text-dark mb-0 fs-16">Custom Order Notes</h5>
                  </div>

                  <div className="mb-2">
                    <ReactQuill
                      theme="snow"
                      value={note}
                      placeholder="Type internal notes or messages for the customer..."
                      onChange={(e) => setNote(e)}
                      style={{ height: '100px', marginBottom: '40px' }}
                    />
                  </div>

                  <div className="d-flex justify-content-end gap-2 mt-auto">
                    <Button
                      color="secondary"
                      outline
                      className="px-4 rounded-2 fw-600 d-flex align-items-center gap-2"
                      onClick={sendNoteToCustomer}
                      disabled={!note || noteloader}
                      style={{ height: '42px' }}
                    >
                      {noteloader ? <Spinner size="sm" /> : <FiSend size={16} />}
                      Send to Customer
                    </Button>
                    <Button
                      color="primary"
                      className="px-4 rounded-2 fw-600 shadow-sm bg-primary-color "
                      onClick={addOrderNote}
                      disabled={!note}
                      style={{ height: '42px' }}
                    >
                      Add Internal Note
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col md={4}>
              <div className="d-flex flex-column h-100">
                <SaleOrderTotalCard
                  totalTaxAmount={totalTaxAmount}
                  setTotalTaxAmount={setTotalTaxAmount}
                  subTotal={subTotal}
                  totalAmount={totalAmount}
                  totalTax={totalTax}
                  orderData={orderData}
                />
                <div className="mt-auto pt-3 d-flex justify-content-end w-100">
                  <GeneralButton
                    title={"Update Sale Order"}
                    width={"100%"}
                    height={"42px"}
                    className={"bg-primary-color shadow-sm rounded-2 fw-bold text-uppercase tracking-wider"}
                    handleClick={handleSubmitOrder}
                    loading={loader}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={8}>
              <CustomOrderNotes
                orderNotes={orderNotes}
                deleteOrderNote={deleteOrderNote}
                updateOrderNote={updateOrderNote}
              />
            </Col>
          </Row>

          <Row className="mx-2 mx-lg-2 ">
            <div className=" py-4">
              <PosInsideSo all_purchase_orders={poDetails} orderData={orderData} />
            </div>

            <div className="my-3">
              <LogTable
                orderNotes={orderNotes
                  ?.filter((i) => {
                    return !i?.personalNote;
                  })
                  .sort((a, b) => b?.createdAt - a?.createdAt)}
              />
            </div>
          </Row>
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              zIndex: 1000,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Button
              color="primary"
              className="rounded-circle p-2 shadow"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              title="Scroll to Top"
            >
              <BiArrowToTop size={24} />
            </Button>
            <Button
              color="primary"
              className="rounded-circle p-2 shadow"
              onClick={() =>
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                })
              }
              title="Scroll to Bottom"
            >
              <BiArrowToBottom size={24} />
            </Button>
          </div>
        </>
      )}
    </>
  );
};
export default SalesOrderDetails;
